'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _close = require('dibs-vg/dist/react/close');

var _close2 = _interopRequireDefault(_close);

var _ErrorMessage = require('../Common/ErrorMessage');

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function themedMultiValueComponent(theme) {
    return function (_React$Component) {
        (0, _inherits3.default)(MultiValueComponent, _React$Component);

        function MultiValueComponent() {
            var _ref;

            var _temp, _this, _ret;

            (0, _classCallCheck3.default)(this, MultiValueComponent);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MultiValueComponent.__proto__ || (0, _getPrototypeOf2.default)(MultiValueComponent)).call.apply(_ref, [this].concat(args))), _this), _this.onRemove = function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this.props.onRemove(_this.props.value);
            }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
        }

        (0, _createClass3.default)(MultiValueComponent, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(
                    'div',
                    {
                        className: theme.multiSelectValueContainer,
                        onMouseDown: this.onRemove
                    },
                    _react2.default.createElement(
                        'span',
                        { className: theme.multiSelectLabel },
                        this.props.children
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: theme.multiSelectCloseContainer },
                        _react2.default.createElement(_close2.default, { className: theme.multiSelectClose })
                    )
                );
            }
        }]);
        return MultiValueComponent;
    }(_react2.default.Component);
}

var Select = function Select(props) {
    var _classNames;

    var name = props.name,
        onChange = props.onChange,
        options = props.options,
        autoComplete = props.autoComplete,
        _props$clearable = props.clearable,
        clearable = _props$clearable === undefined ? false : _props$clearable,
        creatable = props.creatable,
        dataTn = props.dataTn,
        _props$disabled = props.disabled,
        disabled = _props$disabled === undefined ? false : _props$disabled,
        _props$emptyValuePlac = props.emptyValuePlaceholder,
        emptyValuePlaceholder = _props$emptyValuePlac === undefined ? '' : _props$emptyValuePlac,
        errorMessage = props.errorMessage,
        filterOptions = props.filterOptions,
        inputErrorDataTn = props.inputErrorDataTn,
        _props$hasAnimatedPla = props.hasAnimatedPlaceholder,
        hasAnimatedPlaceholder = _props$hasAnimatedPla === undefined ? false : _props$hasAnimatedPla,
        _props$isLoading = props.isLoading,
        isLoading = _props$isLoading === undefined ? false : _props$isLoading,
        isOptionUnique = props.isOptionUnique,
        isValid = props.isValid,
        isValidNewOption = props.isValidNewOption,
        multi = props.multi,
        newOptionCreator = props.newOptionCreator,
        onInputChange = props.onInputChange,
        onNewOptionClick = props.onNewOptionClick,
        _props$placeholder = props.placeholder,
        placeholder = _props$placeholder === undefined ? '' : _props$placeholder,
        promptTextCreator = props.promptTextCreator,
        _props$searchable = props.searchable,
        searchable = _props$searchable === undefined ? false : _props$searchable,
        size = props.size,
        shouldKeyDownEventCreateNewOption = props.shouldKeyDownEventCreateNewOption,
        theme = props.theme,
        value = props.value,
        wrapperClass = props.wrapperClass;


    if (!theme) {
        return null;
    }

    if (process.env.NODE_ENV === 'dev') {
        if (placeholder) {
            console.warn("dibs-elements | Select | property 'placeholder' has changed! If you intend to see the placholder animate and go above the selected value when chosen, please add the property 'hasAnimatedPlaceholder'. Otherwise, the default behavior will make the placeholder disappear. <3 Majd");
        }

        if (emptyValuePlaceholder) {
            console.warn("dibs-elements | Select | property 'emptyValuePlaceholder' is deprecated. Use 'placeholder' instead. <3 Majd");
        }
    }

    var inputProps = { name: name, autoComplete: autoComplete ? 'on' : 'off' };
    var selectWrapperClasses = (0, _classnames2.default)(wrapperClass, theme.field);
    var selectClasses = (0, _classnames2.default)(theme.select, (_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.valid, isValid), (0, _defineProperty3.default)(_classNames, theme.disabled, disabled), (0, _defineProperty3.default)(_classNames, theme.error, !!errorMessage), (0, _defineProperty3.default)(_classNames, theme.withPlaceholder, placeholder || emptyValuePlaceholder), (0, _defineProperty3.default)(_classNames, theme.withoutAnimatedPlaceholder, !hasAnimatedPlaceholder || searchable), (0, _defineProperty3.default)(_classNames, theme.heightDefault, !size), (0, _defineProperty3.default)(_classNames, theme.heightSmall, size === 'small'), (0, _defineProperty3.default)(_classNames, theme.heightMedium, size === 'medium'), (0, _defineProperty3.default)(_classNames, theme.heightLarge, size === 'large'), _classNames));

    var placeholderClasses = (0, _classnames2.default)(theme.placeholder, (0, _defineProperty3.default)({}, theme.placeholderWithoutValue, (placeholder || emptyValuePlaceholder) && !value));

    var noResultsText = props.noResultsText;

    if (isLoading && options.length === 0) {
        noResultsText = '';
    }

    var additionalOptions = {};
    var SelectElement = _reactSelect2.default;

    if (creatable) {
        SelectElement = _reactSelect2.default.Creatable;
        additionalOptions = {
            isOptionUnique: isOptionUnique,
            isValidNewOption: isValidNewOption,
            newOptionCreator: newOptionCreator,
            onNewOptionClick: onNewOptionClick,
            shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
            promptTextCreator: promptTextCreator
        };
    }

    var nativePlaceholder = searchable || !hasAnimatedPlaceholder ? placeholder || emptyValuePlaceholder : "";

    return _react2.default.createElement(
        'div',
        { className: selectWrapperClasses, 'data-field': name },
        _react2.default.createElement(
            'div',
            {
                className: selectClasses,
                'data-tn': dataTn
            },
            _react2.default.createElement(SelectElement, (0, _extends3.default)({}, additionalOptions, {
                name: name,
                value: value,
                isLoading: isLoading,
                inputProps: inputProps,
                options: options,
                disabled: disabled,
                clearable: clearable,
                searchable: searchable,
                filterOptions: filterOptions,
                noResultsText: noResultsText,
                scrollMenuIntoView: false,
                placeholder: nativePlaceholder,
                onChange: function (_onChange) {
                    function onChange(_x) {
                        return _onChange.apply(this, arguments);
                    }

                    onChange.toString = function () {
                        return _onChange.toString();
                    };

                    return onChange;
                }(function (opts) {
                    if (onChange) {
                        if (Array.isArray(opts)) {
                            onChange(opts.map(function (opt) {
                                return (0, _assign2.default)({}, opt, { name: name });
                            }));
                        } else {
                            onChange(opts ? (0, _assign2.default)({}, opts, { name: name }) : null);
                        }
                    }
                }),
                onInputChange: function (_onInputChange) {
                    function onInputChange(_x2) {
                        return _onInputChange.apply(this, arguments);
                    }

                    onInputChange.toString = function () {
                        return _onInputChange.toString();
                    };

                    return onInputChange;
                }(function (inputValue) {
                    if (onInputChange) {
                        var result = onInputChange(inputValue);
                        return result || inputValue;
                    } else {
                        return inputValue;
                    }
                }),
                multi: multi,
                valueComponent: multi && themedMultiValueComponent(theme)
            })),
            !searchable && hasAnimatedPlaceholder && (placeholder || emptyValuePlaceholder) && _react2.default.createElement(
                'span',
                { className: placeholderClasses },
                placeholder || emptyValuePlaceholder
            )
        ),
        _react2.default.createElement(_ErrorMessage2.default, {
            message: errorMessage,
            dataTn: inputErrorDataTn,
            className: theme.inputErrorMessage
        })
    );
};

Select.displayName = 'Select';

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Select/index.js
// module id = ./node_modules/dibs-elements/lib/Select/index.js
// module chunks = 4